
import { Component, Mixins } from 'vue-mixin-decorator';

import Dropdown from '@/mixins/common/dropdown';

@Component
export default class StepCostVinInfo extends Mixins<Dropdown>(Dropdown) {}
